module.exports = __webpack_public_path__ + "media/era_sweepstakes/facebook-46b66db5.svg";